import { render, staticRenderFns } from "./FormCreateMenuOptional.vue?vue&type=template&id=ea6fb2d6"
import script from "./FormCreateMenuOptional.vue?vue&type=script&lang=js"
export * from "./FormCreateMenuOptional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports